import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'ui-components/components/checkbox';
import { Input } from 'ui-components/components/input';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import style from './style.module.less';
import { checkBoxFields, selectFields } from './constants';

const EditDeviceModalField = ({ fieldName, fieldValue, setDevice }) => {
  const onChange = useCallback(
    (event) => {
      const {
        target: { value, name },
      } = event;
      setDevice((d) => ({ ...d, [name]: value }));
    },
    [setDevice],
  );

  const onCheckboxChange = useCallback(
    (checked, event) => {
      const { name } = event.target;
      setDevice((d) => ({ ...d, [name]: checked }));
    },
    [setDevice],
  );

  const onSelectChange = useCallback(
    (field, value) => {
      setDevice((d) => ({ ...d, [field]: value }));
    },
    [setDevice],
  );

  if (checkBoxFields.includes(fieldName)) {
    return <Checkbox key={fieldName} checked={fieldValue} className={style.checkbox} name={fieldName} onChange={onCheckboxChange} />;
  }

  if (Object.keys(selectFields).includes(fieldName)) {
    return (
      <DropdownMenu key={fieldName} dropdownMenuShouldHaveWidthOfButton fullWidth variant='form'>
        <DropdownMenuToggler theme='white'>{fieldValue}</DropdownMenuToggler>
        {selectFields[fieldName].map((value) => (
          <DropdownMenuItem key={fieldName} onClick={() => onSelectChange(fieldName, value)} selected={fieldValue === value}>
            {value}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    );
  }

  return (
    <Input key={fieldName} className={style.input} exposeNativeEventInCallbacks name={fieldName} onChange={onChange} value={fieldValue} />
  );
};

export default EditDeviceModalField;

EditDeviceModalField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldValue: PropTypes.string.isRequired,
  setDevice: PropTypes.func.isRequired,
};
